import { requireTranslations } from '../../translation';

export default requireTranslations((locale: string) => require(`./data-search.${locale}.json`));
